import { render, staticRenderFns } from "./activitylist.vue?vue&type=template&id=df2bbb4a&"
import script from "./activitylist.vue?vue&type=script&lang=js&"
export * from "./activitylist.vue?vue&type=script&lang=js&"
import style0 from "./activitylist.vue?vue&type=style&index=0&id=df2bbb4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports